import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'app-toolbar-options-section',
    templateUrl: './toolbar-options-section.component.html',
    styleUrls: ['./toolbar-options-section.component.scss'],
    standalone: false
})
export class ToolbarOptionsSectionComponent {
  @HostBinding('class') classes = 'flex-column';
}
